/**
 * @fileoverview POST handler for the "/engagement/report_dashboard" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementReportDashboardCacheKeys } from "./constants";
import type { PostEngagementReportDashboardProps, EngagementReportDashboardResult } from "./types";

export const postEngagementReportDashboard = reactQueryMutationAdapter(
  engagementReportDashboardCacheKeys,
  (props: PostEngagementReportDashboardProps): Promise<EngagementReportDashboardResult> => {
    return fetch("/engagement/report_dashboard", "POST", props);
  }
);
